export function defaultTo(getValueFunc, defaultValue) {
    try {
        var response = getValueFunc();
        if (isNaN(response) || response == undefined) return defaultValue;
        return response;
    } catch (e) {
        return defaultValue;
    }
}
